module.exports = __webpack_public_path__ + "img/douyin2s.1e827eb0.png";